import React from 'react';

import { IconButton, Tooltip } from '@zapier/design-system';

type Props = {
  message: string;
};

function LockedNavCog({ message }: Props) {
  return (
    <Tooltip content={message}>
      <IconButton
        aria-label="More actions"
        isDisabled={true}
        name="navMoreHoriz"
        variant="ghost"
        size="small"
      />
    </Tooltip>
  );
}

export default LockedNavCog;
